// extracted by mini-css-extract-plugin
export default {"table-head-cell":"iR_yK9tbxPYZ7c6","left":"KwOA7aL_ZiipsJt","right":"pUKVFc39PxzGiKV","center":"xSlxGTIIzhS517M"};